import Box from "@mui/material/Box";
import { ReactElement, ReactNode } from "react";
import { LogoInfoMenu } from "../LogoInfoMenu";
import { LegalFooter } from "./LegalFooter";
import { WebsiteHeader } from "./WebsiteHeader";

/**
 * Marketing / landing chrome: optional logo header, main content, legal footer.
 */
export function WebsiteLayout({
  children,
  showHeader = true,
}: {
  children: ReactNode;
  showHeader?: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto",
        minHeight: 0,
      }}
    >
      {showHeader ? <WebsiteHeader /> : null}
      <Box sx={{ flex: "1 1 auto", minHeight: 0 }}>{children}</Box>
      <LegalFooter />
      <LogoInfoMenu />
    </Box>
  );
}

/** Use as static `getLayout` on website-layout pages (e.g. landing). */
export function getWebsiteLayout(page: ReactElement) {
  return <WebsiteLayout>{page}</WebsiteLayout>;
}
